import { CampaignState, CampaignType } from 'modules/domains/campaign';
import {
  ExperimentState,
  ExperimentType,
  ExperimentWinningCriteriaDefinition,
  MessageMedium,
} from 'modules/graphql/types';
import {
  BasePageExperimentData,
  ExperimentAnalyticsTranslation,
  OverviewTabExperimentData,
  PerformanceTabExperimentData,
} from '../types';

export const initialAnalyticsBasePageData: BasePageExperimentData = {
  id: 0,
  campaign: {
    id: 0,
    name: '',
    type: '' as CampaignType,
    messageMedium: '' as MessageMedium,
    labels: [],
    sendTimeUseRecipientTimeZones: false,
    state: '' as CampaignState,
    conversions: [],
  },
  name: '',
  type: '' as ExperimentType,
  createdAt: '',
  createdBy: {
    id: '',
    fullName: '',
  },
  modifiedAt: '',
  startedAt: '',
  endedAt: '',
  exploitationStartedAt: '',
  testDurationInMinutes: 0,
  testSizePercentage: 0,
  state: '' as ExperimentState,
  evenlySplitVariations: false,
  winningCriteria: {} as ExperimentWinningCriteriaDefinition,
  variations: [],
  attributionPeriodHours: null,
  holdout: {
    percent: 0,
  },
  testSendsPerVariation: null,
};

export const initialAnalyticsOverviewTabData: OverviewTabExperimentData = {
  holdout: {
    holdoutUserCount: null,
    experimentWinningCriteria: null,
  },
  variations: [],
};

export const initialAnalyticsPerformanceTabData: PerformanceTabExperimentData = {
  holdout: {
    holdoutUserCount: null,
    experimentWinningCriteria: null,
    metrics: [],
  },
  variations: [],
};

export const initialTranslationData: ExperimentAnalyticsTranslation = {
  badge: {},
  detailsMetadata: {},
  experimentType: {},
  monitor: {
    export: {
      defaultHeaders: {},
    },
  },
  metrics: {},
  notSet: {},
  placeholder: {},
};
